export const hasOngoingBackendCall = (state) =>
  state.isCreatingNode ||
  state.isRenamingNode ||
  state.isDeletingNode ||
  state.isMovingNode
